export const formColumn = () => {
  return [
    {
      name: '应收账期',
      prop: 'accountPeriod',
      type: 'month',
      format: 'yyyy-MM',
    },
    {
      name: '合同编号：',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '客户名称：',
      prop: 'customerName',
      type: 'input',
    },
  ];
};
export const contractColumn = [
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
    width: 180,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
    width: 180,
  },

  {
    field: 'contractStatus',
    title: '合同状态',
    visible: true,
  },
  {
    field: 'leaseDateFrom',
    title: '租赁开始时间',
    visible: true,
  },
  {
    field: 'leaseDateUntil',
    title: '租赁结束时间',
    visible: true,
  },
];
export const generateColumn = [
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },

  {
    field: 'accountPeriod',
    title: '应收账期',
    visible: true,
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'expenseType',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'energyMeterCode',
    title: '能耗表编号',
    visible: true,
  },
  {
    field: 'energyMeterTypeName',
    title: '能耗表类型',
    visible: true,
  },
  {
    field: 'originalPrice',
    title: '结算单价（含税）',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },

  {
    field: 'originalAmount',
    title: '原币结算金额（含税）',
    visible: true,
  },
  {
    field: 'unitName',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    visible: true,
  },
  {
    field: 'spaceAssetName',
    title: '空间资产',
    visible: true,
  },
];
